import type { NotificationType } from './core/NotificationType';
import { riskRecognitionType } from './types/risk-recognition/riskRecognition.type';

/**
 * Registro estático de todos os tipos de notificação. Adicionar um tipo = criar `types/<tipo>/` e somar a
 * este array. As surfaces genéricas iteram o registry; nenhuma surface precisa ser editada para um tipo novo.
 */
export const notificationTypes: ReadonlyArray<NotificationType> = [riskRecognitionType];

export const getCardTypes = (): ReadonlyArray<NotificationType> => notificationTypes.filter((type) => type.surfaces.card && !!type.useCardController);

export const getToastTypes = (): ReadonlyArray<NotificationType> => notificationTypes.filter((type) => type.surfaces.toast && !!type.useToastController);

export const getDrawerTypes = (): ReadonlyArray<NotificationType> => notificationTypes.filter((type) => type.surfaces.drawer && !!type.Drawer);

export const getTypeByKey = (key: string): NotificationType | undefined => notificationTypes.find((type) => type.key === key);
